import api from './api';

export interface CreateFeedbackPayload {
  name?: string;
  email?: string;
  rating: number;
  message: string;
}

export const feedbackService = {
  submitFeedback: async (payload: CreateFeedbackPayload): Promise<{ message: string }> => {
    const response = await api.post('/feedback', payload);
    return response.data;
  },
};
